import React from 'react'

interface CountInterface {
  totalItems: number|any[],
  name: string,
  classNames?: string,
}

const Count = ({totalItems, name, classNames}: CountInterface) => {
  return (
    <div className={classNames}>
      <b>{totalItems}</b>
      {` ${name}${totalItems > 1 ? 's' : ''}`}
    </div>
  )
}

export default Count
